import {
    SET_IS_LOAD,
    SET_TITLE,
    SET_AUTH_DATA,
    CLEAR_AUTH_DATA,
    SET_FILTER,
    SET_REFRESH_INTERVAL,
    SET_PAGE_REFRESH_INTERVAL,
    SET_MENU_GROUP_STATE,
} from "./consts";

export const setIsLoad = (isLoad) => ({ type: SET_IS_LOAD, payload: isLoad });

export const setTitle = (title) => ({ type: SET_TITLE, payload: title });

// payload: {isAuth, accessToken, refreshToken, expAccessToken, expRefreshToken,
//           userPermissions, userRoles, user}
export const setAuthData = (authData) => ({ type: SET_AUTH_DATA, payload: authData });

export const clearAuthData = () => ({ type: CLEAR_AUTH_DATA });

export const setFilter = (filter) => ({ type: SET_FILTER, payload: filter });

export const setRefreshInterval = (seconds) => ({ type: SET_REFRESH_INTERVAL, payload: seconds });

export const setPageRefreshInterval = (pathname, seconds) => ({
    type: SET_PAGE_REFRESH_INTERVAL,
    payload: { pathname, seconds },
});

export const setMenuGroupState = (group, isOpen) => ({
    type: SET_MENU_GROUP_STATE,
    payload: { group, isOpen },
});
